import { Component, Input } from '@angular/core';
import { InfoPageType } from 'src/app/@core/enums/info-page-type.enum';

@Component({
  selector: 'info-page',
  templateUrl: './info-page.component.html',
  styleUrls: ['./info-page.component.scss'],
})
export class InfoPageComponent {
  @Input() infoType!: InfoPageType;

  constructor() {}
}
